<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
                   [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg" [token]="token">

  <ng-container *ngIf="consulta">
    <ul class="card-list-striped py-1">
      <li>
        <span class="text-secondary">SITUAÇÃO DO VEÍCULO</span>
        <span>{{consulta?.situacaoVeiculo || 'NÃO INFORMADO'}}</span>
      </li>
      <li>
        <span class="text-secondary">SITUAÇÃO DO CHASSI</span>
        <span>{{consulta?.tipoRemarcacaoChassi || 'NÃO INFORMADO'}}</span>
      </li>
      <li>
        <span class="text-secondary">VEÍCULO ROUBADO</span>
        <span *ngIf="possuiRouboFurtoEstadual" class="text-danger fw-500">SIM</span>
        <span *ngIf="!possuiRouboFurtoEstadual" class="">NÃO</span>
    </li>
    </ul>

    <h2 class="subtitle">DADOS CADASTRAIS</h2>
    <ul class="card-list-striped">
      <li><span class="text-secondary">PLACA</span><span>{{consulta?.placa || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">CHASSI</span><span>{{consulta?.chassi || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">NÚMERO DE MOTOR
          ORIGINAL</span><span>{{consulta?.nrMotorOriginal || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">NÚMERO DE MOTOR
          ATUAL</span><span>{{consulta?.nrMotor || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">NÚMERO DA CAIXA DE
          CÂMBIO</span><span>{{consulta?.nrCaixaCambio || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">POTÊNCIA</span><span>{{consulta?.potencia || 'NÃO INFORMADO'}}</span>
      </li>
      <li><span class="text-secondary">CILINDRADAS</span><span>{{consulta?.cilindrada || 'NÃO INFORMADO'}}</span>
      </li>
      <li><span class="text-secondary">RENAVAM</span><span>{{consulta?.renavam || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">TIPO DE DOCUMENTO DO COMPRADOR</span>
        <span>{{tipoDocComprador || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">DATA DE EMISSÃO DO
          CRV/CRLV</span><span>{{consulta?.dataEmissaoCrvCrvl || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">DATA DE
          LICENCIAMENTO</span><span>{{consulta?.dataLicenciamento || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">DATA DA ÚLTIMA
          ATUALIZAÇÃO</span><span>{{consulta?.dataUltimaAtualizacao || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">MUNICÍPIO/UF</span> <span>{{consulta?.municipio || 'NÃO INFORMADO'}} /
          {{consulta?.uf || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">CPF/CNPJ
          Faturado:</span><span>{{consulta?.cpfCnpjFaturado || 'NÃO INFORMADO'}}</span></li>
    </ul>

    <h2 class="subtitle">DESCRIÇÃO DO VEÍCULO</h2>
    <ul class="card-list-striped">
      <li><span class="text-secondary">MARCA/MODELO</span> <span>{{consulta?.marca || 'NÃO INFORMADO'}} /
          {{consulta?.modelo || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">COR</span><span>{{consulta?.cor || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">ANO DE FABRICAÇÃO</span>
        <span>{{consulta?.anoFabricacao || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">ESPÉCIE</span> <span>{{consulta?.especie || 'NÃO INFORMADO'}}</span>
      </li>
      <li><span class="text-secondary">ANO DO MODELO</span>
        <span>{{consulta?.anoModelo || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">NÚMERO DE PASSAGEIROS</span>
        <span>{{consulta?.capacidadePassageiros || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">COMBUSTÍVEL</span>
        <span>{{consulta?.combustivel || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">CATEGORIA</span> <span>{{consulta?.categoria || 'NÃO INFORMADO'}}</span>
      </li>
      <li><span class="text-secondary">SEGMENTO</span> <span>{{consulta?.segmento || 'NÃO INFORMADO'}}</span>
      </li>
      <li><span class="text-secondary">SUBSEGMENTO</span>
        <span>{{consulta?.subsegmento || 'NÃO INFORMADO'}}</span></li>
    </ul>

    <h2 class="subtitle">PROPRIETÁRIOS</h2>
    <ul class="card-list-striped card-list-striped-3">
      <li><span class="text-secondary">PROPRIETÁRIO
          ANTERIOR</span><span>{{consulta?.proprietarioAnterior || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">PROPRIETÁRIO
          ATUAL</span><span>{{consulta?.proprietario || 'NÃO INFORMADO'}}</span></li>
      <li><span  class="text-secondary">CPF/CNPJ
          COMPRADOR</span><span class="documentoPropBin">{{ consulta?.cpfCnpjProprietario  || 'NÃO INFORMADO'}}</span></li>
    </ul>

    <h2 class="subtitle">FICHA TÉCNICA</h2>
    <ul class="card-list-striped">
      <li><span class="text-secondary">TIPO DE MONTAGEM</span>
        <span>{{consulta?.montagem || tipoMontagem ||'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">TIPO DE VEÍCULO</span>
        <span>{{consulta?.tipo || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">PESO BRUTO TOTAL</span>
        <span>{{consulta?.pbt || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">CAPACIDADE DE CARGA</span>
        <span>{{consulta?.capacidadeDeCarga || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">CAPACIDADE MÁXIMA DE
          TRAÇÃO</span><span>{{consulta?.cmt || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">TIPO DE CARROCERIA</span>
        <span>{{consulta?.tipoCarroceria || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">NÚMERO DA CARROCERIA</span>
        <span>{{consulta?.nrCarroceria || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">CARROCERIA</span>
        <span>{{consulta?.carroceria || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">QUANTIDADE DE EIXOS</span>
        <span>{{consulta?.nrEixos || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">TERCEIRO
          EIXO</span><span>{{consulta?.terceiroEixo || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">EIXO TRASEIRO DIFERENCIAL</span>
        <span>{{consulta?.eixoTrasDiferencial || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">PROTOCOLO DETRAN</span>
        <span>{{consulta?.protocoloDetran || 'NÃO INFORMADO'}}</span></li>
    </ul>

    <div *ngIf="dadosComunicacaoVenda">
      <h2 id="comunicacao_venda_estadual" class="subtitle">COMUNICAÇÃO DE VENDA</h2>
      <ul class="card-list-striped">
        <li><span class="text-secondary">DATA DE VENDA</span> <span>{{consulta?.dataVenda || 'NÃO INFORMADO'}}
          </span></li>
        <li><span class="text-secondary">DATA DE INCLUSÃO DE VENDA</span>
          <span>{{consulta?.dataInclusaoVenda || 'NÃO INFORMADO'}} </span></li>
        <li><span class="text-secondary">ANO EXERCÍCIO DO LICENCIAMENTO</span>
          <span>{{consulta?.anoExercicioLicenciamento || 'NÃO INFORMADO'}} </span></li>
        <li><span class="text-secondary">INDICADOR COMUNICAÇÃO DE VENDA</span>
          <span>{{consulta?.indicadorComunicaVenda || 'NÃO INFORMADO'}} </span></li>
        <!-- <li><span class="text-secondary">CPF/CNPJ FINANCIADO</span> <span>{{consulta?.cpfCnpjFinanciado || 'NÃO INFORMADO'}} </span></li>
        <li><span class="text-secondary">INDICADOR COMUNICAÇÃO VENDA</span> <span>{{dadosNacionais?.indicadorComunicaVenda || 'NÃO INFORMADO'}} </span></li> -->
      </ul>
    </div>

    <div *ngIf="showVistorias">
      <h2 class="subtitle">HISTÓRICO DE QUILOMETRAGEM</h2>
      <ul class="card-list-striped">
        <li *ngFor="let vistoria of vistorias">
          <span class="text-secondary">{{vistoria?.dataVistoria || 'NÃO INFORMADO'}}</span>
          <span>{{vistoria?.km || 'NÃO INFORMADO'}}</span>
        </li>
      </ul>
    </div>

    <h2 class="subtitle">RESTRIÇÕES</h2>
    <ul class="card-list-striped">
      <li>
        <span class="text-secondary">ADMINISTRATIVA</span>
        <span [ngClass]="{'text-danger fw-500': restricaoAdministrativa }">
          <span>{{restricaoAdministrativa || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">ALIENAÇÃO</span>
        <span [ngClass]="{'text-danger fw-500': alienacao }">
          <span>{{alienacao || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">ARRENDAMENTO</span>
        <span [ngClass]="{'text-danger fw-500': arrendamento }">
          <span>{{arrendamento || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">JUDICIAL</span>
        <span [ngClass]="{'text-danger fw-500': restricaoJudicial }">
          <span>{{restricaoJudicial || restricaoJudicialOK || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">RESERVA DE DOMÍNIO</span>
        <span [ngClass]="{'text-danger fw-500': reservaDominio }">
          <span>{{reservaDominio || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">ROUBO E FURTO ATIVO</span>
        <span [ngClass]="{'text-danger fw-500': rouboFurto }">
          <span>{{rouboFurto || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">SINISTRO RECUPERADO</span>
        <span [ngClass]="{'text-danger fw-500': sinistroRecuperado }">
          <span>{{sinistroRecuperado || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">TRIBUTÁRIO</span>
        <span [ngClass]="{'text-danger fw-500': restricaoTributaria }">
          <span>{{restricaoTributaria || 'NADA CONSTA'}}</span>
        </span>
      </li>
      <li>
        <span class="text-secondary">OBSERVAÇÕES</span>
        <span [ngClass]="{'text-danger fw-500': observacoes }">
          <span>{{observacoes || observacoesOK || 'NADA CONSTA'}}</span>
        </span>
      </li>
    </ul>

    <div *ngIf="showGravame">
      <h2 class="subtitle">GRAVAME</h2>
      <ul class="card-list-striped">
        <li><span class="text-secondary">AGENTE FINANCEIRO</span>
          <span>{{consulta?.nomeAgenteFinanceiro || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">NOME
            FINANCIADO</span><span>{{consulta?.nomeFinanciado || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">DATA DE INCLUSÃO</span>
          <span>{{consulta?.dataInclusaoFinanc || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">RESTRIÇÃO FINANCEIRA</span>
          <span>{{consulta?.tipoRestricaoFinanceira || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">CPF/CNPJ FINANCIADO</span>
          <span>{{consulta?.cpfCnpjFinanciado || 'NÃO INFORMADO'}}</span></li>
      </ul>
    </div>

    <div *ngIf="showIntencaoGravame">
      <h2 class="subtitle">INTENÇÃO GRAVAME</h2>
      <ul class="card-list-striped">

        <li><span class="text-secondary">AGENTE FINANCEIRO</span>
          <span>{{consulta?.nomeAgenteFinanceiroIntencaoGravame || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">CPF/CNPJ FINANCIADO</span>
          <span>{{consulta?.cpfCnpjFinanciadoIntencaoGravame || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">DATA DE INCLUSÃO</span>
          <span>{{consulta?.dataInclusaoIntencaoGravame || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">NOME
            FINANCIADO</span><span>{{consulta?.nomeFinanciadoIntencaoGravame || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">RESTRIÇÃO FINANCEIRA</span>
          <span>{{consulta?.restricaoFinanceiraIntencaoGravame || 'NÃO INFORMADO'}}</span></li>

      </ul>
    </div>

    <div>
      <h2 class="subtitle">DÉBITOS</h2>
      <ul class="card-list-striped">
        <li>
          <span class="text-secondary">CETESB</span>
          <span [ngClass]="{'fw-500 text-danger': consulta?.valorDebitoCetesb && consulta?.valorDebitoCetesb.trim() != '0,00' }">R$
            {{consulta?.valorDebitoCetesb || '0,00'}}</span>
        </li>
        <li>
          <span class="text-secondary">DER</span>
          <span [ngClass]="{'fw-500 text-danger': consulta?.valorDebitoDer && consulta?.valorDebitoDer.trim() != '0,00' }">R$
            {{consulta?.valorDebitoDer || '0,00'}}</span>
        </li>
        <li>
          <span class="text-secondary">DERSA</span>
          <span [ngClass]="{'fw-500 text-danger': consulta?.valorDebitoDersa && consulta?.valorDebitoDersa.trim() != '0,00' }">R$
            {{consulta?.valorDebitoDersa || '0,00'}}</span>
        </li>
        <li>
          <span class="text-secondary">DETRAN</span>
          <span [ngClass]="{'fw-500 text-danger': consulta?.valorDebitoDetran && consulta?.valorDebitoDetran.trim() != '0,00' }">R$
            {{consulta?.valorDebitoDetran || '0,00'}}</span>
        </li>
        <li>
          <span class="text-secondary">IPVA</span>
          <span *ngIf="!ocorrenciaIpva" [ngClass]="{'fw-500 text-danger': ( (consulta?.valorDebitoIpva && consulta?.valorDebitoIpva.trim() != '0,00') ) }">
            <span *ngIf="isNumber(consulta?.valorDebitoIpva)">R$</span>
            {{consulta?.valorDebitoIpva || '0,00'}}</span>
          <span *ngIf="ocorrenciaIpva" class="fw-500 text-danger">EXISTE DÉBITO IPVA</span>
        </li>
        <li>
          <span class="text-secondary">MUNICIPAIS</span>
          <span [ngClass]="{'fw-500 text-danger': consulta?.valorDebitoMunicipais && consulta?.valorDebitoMunicipais.trim() != '0,00' }">R$
            {{consulta?.valorDebitoMunicipais || '0,00'}}</span>
        </li>
        <li>
          <span class="text-secondary">PRF</span>
          <span [ngClass]="{'fw-500 text-danger': consulta?.valorDebitoPrf && consulta?.valorDebitoPrf.trim() != '0,00' }">R$
            {{consulta?.valorDebitoPrf || '0,00'}}</span>
        </li>
        <li>
          <span class="text-secondary">RENAINF</span>
          <span [ngClass]="{'fw-500 text-danger': consulta?.valorDebitoRenainf && consulta?.valorDebitoRenainf.trim() != '0,00' }">R$
            {{consulta?.valorDebitoRenainf || '0,00'}}</span>
        </li>
        <li>
          <span class="text-secondary">LICENCIAMENTO</span>
          <span *ngIf="!ocorrenciaLicenciamento" [ngClass]="{'fw-500 text-danger': consulta?.valorDebitoLicenc && consulta?.valorDebitoLicenc.trim() != '0,00' }">
            <span *ngIf="isNumber(consulta?.valorDebitoLicenc)">R$</span>
            {{consulta?.valorDebitoLicenc || '0,00'}}</span>
          <span *ngIf="ocorrenciaLicenciamento" class="fw-500 text-danger">EXISTE DÉBITO DE LICENCIAMENTO</span>
        </li>
        <li>
          <span class="text-secondary">MULTAS</span>
          <span *ngIf="!ocorrenciaMultas" [ngClass]="{'fw-500 text-danger': consulta?.valorDebitoMultas && consulta?.valorDebitoMultas.trim() != '0,00' }">
            <span *ngIf="isNumber(consulta?.valorDebitoMultas)">R$</span>
            {{consulta?.valorDebitoMultas || '0,00'}}</span>
          <span *ngIf="ocorrenciaMultas" class="fw-500 text-danger">EXISTE DÉBITO DE MULTAS</span>
        </li>
        <li>
          <span class="text-secondary">DPVAT</span>
          <span *ngIf="!ocorrenciaDpvat" [ngClass]="{'fw-500 text-danger': consulta?.valorDebitoDpvat && consulta?.valorDebitoDpvat.trim() != '0,00' }">
            <span *ngIf="isNumber(consulta?.valorDebitoDpvat)">R$</span>
            {{consulta?.valorDebitoDpvat || '0,00'}}</span>
          <span *ngIf="ocorrenciaDpvat" class="fw-500 text-danger">EXISTE DÉBITO DE DPVAT</span>
        </li>
      </ul>
    </div>

  </ng-container>

</app-card-consulta>
